import type { TourDef } from './index';

const a = (id: string): string => `[data-tour="${id}"]`;

/** First-run tour for `/reports` (register in tours/index.ts and set `tourId: 'reports'` on the route — see docs/proposals/agent-g.md). */
export const reportsTour: TourDef = {
  id: 'reports',
  steps: [
    { element: a('reports-grid'), popover: { title: 'Every report in one place', description: 'Money, budgets, tax, investing, statements and the audit log. Each one takes a date range or financial year.' } },
    { element: a('reports-pack'), popover: { title: 'Accountant pack', description: 'Downloads the CGT schedule, income & franking, holdings and the transaction register for the financial year as CSV files.' } },
  ],
};
